module.exports = __webpack_public_path__ + "media/bootstrap-icons/music-note-beamed-f945aeb0.svg";